import { Component } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { HeaderService } from "../../shared/services/header.service";

@Component({
    selector: "app-error",
    standalone: true,
    imports: [NgOptimizedImage, MatButton],
    templateUrl: "./error.component.html",
    styleUrl: "./error.component.scss",
})
export class ErrorComponent {
    constructor(private headerService: HeaderService) {}

    onBack(): void {
        this.headerService.sendExitWebViewMessage();
    }
}
